"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var IconBase_1 = __importDefault(require("../IconBase"));
var util_1 = require("../util");
var Done = function (props) {
    var _a = (0, util_1.getVariantClassNames)(props), primary = _a.primary, secondary = _a.secondary;
    return (react_1.default.createElement(IconBase_1.default, __assign({}, props),
        react_1.default.createElement("path", { d: "M19.9999 36.6673C29.2047 36.6673 36.6666 29.2054 36.6666 20.0007C36.6666 10.7959 29.2047 3.33398 19.9999 3.33398C10.7952 3.33398 3.33325 10.7959 3.33325 20.0007C3.33325 29.2054 10.7952 36.6673 19.9999 36.6673Z", className: primary }),
        react_1.default.createElement("path", { d: "M27.9168 13.0006C28.5835 12.334 29.5835 12.2506 30.2501 12.9173C30.9168 13.584 31.0001 14.584 30.3335 15.2506L18.6668 27.7506C18.0835 28.4173 17.0001 28.5006 16.3335 27.9173L10.5001 22.9173C9.83345 22.334 9.75012 21.2506 10.3335 20.584C10.9168 19.9173 12.0001 19.834 12.6668 20.4173L17.2501 24.4173L27.9168 13.0006Z", className: secondary })));
};
exports.default = Done;
